import { Middleware } from "@reduxjs/toolkit";
import { setSelectedTenant } from "@/services/tenant/tenant-slice";
import { setSelectedClient } from "@/services/client/client-slice";
import { logout } from "@/services/auth/auth-slice";

// Persist only IDs to localStorage to restore user context across refreshes
export const selectionMiddleware: Middleware = () => (next) => (action) => {
  // Persist tenant selection ID changes
  if (setSelectedTenant.match(action)) {
    const tenant = action.payload as ITenant | undefined;
    try {
      if (tenant && tenant._id) {
        localStorage.setItem("selectedTenantId", tenant._id);
      } else {
        localStorage.removeItem("selectedTenantId");
      }
      // Changing tenant should clear persisted client selection to avoid cross-tenant mismatch
      // But blindly removing it here breaks hydration on refresh.
      // We rely on UI/Logic (TenantPicker) to clear the selected client state explicitly when user changes tenant.
      // if (tenant) {
      //   localStorage.removeItem("selectedClientId");
      // }
    } catch {}
  }

  // Persist client selection ID changes
  if (setSelectedClient.match(action)) {
    const client = action.payload as Client | undefined;
    try {
      if (client && client._id) {
        localStorage.setItem("selectedClientId", client._id);
      } else {
        localStorage.removeItem("selectedClientId");
      }
    } catch {}
  }

  // Clear persisted selections on logout
  if (logout.match(action)) {
    try {
      localStorage.removeItem("selectedTenantId");
      localStorage.removeItem("selectedClientId");
    } catch {}
  }

  return next(action);
};


